import { render, staticRenderFns } from "./FreightExchangeMain.vue?vue&type=template&id=ac1b6456&scoped=true"
import script from "./FreightExchangeMain.vue?vue&type=script&setup=true&lang=js"
export * from "./FreightExchangeMain.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FreightExchangeMain.vue?vue&type=style&index=0&id=ac1b6456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1b6456",
  null
  
)

export default component.exports